import Vue from "vue";
import {
  Button,
  Form,
  FormItem,
  Input,
  Message,
  Row,
  Col,
  Loading,
  Breadcrumb,
  BreadcrumbItem,
  Container,
  Header,
  Main,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Tag,
  Aside,
  Footer,
  Progress,
  Radio,
  RadioGroup,
  Empty,
  CheckboxGroup,
  Checkbox,
  MessageBox
} from "element-ui";
Vue.use(Container);
Vue.use(Header);
Vue.use(Main);
Vue.use(Button);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Row);
Vue.use(Col);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Tag);
Vue.use(Aside);
Vue.use(Footer);
Vue.use(Progress)
Vue.use(Radio);
Vue.use(RadioGroup)
Vue.use(Empty)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.prototype.$message = Message;
Vue.prototype.$loading = Loading;
Vue.prototype.$messageBox  = MessageBox;
